import React from 'react';
import { Link } from 'react-router-dom';
export const ServiceTiers = () => {
  return <section className="w-full px-6 py-20 md:px-12 md:py-28 bg-black relative" data-id="element-83">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.05),transparent_50%)] pointer-events-none" data-id="element-84"></div>
      <div className="max-w-3xl mx-auto text-center relative" data-id="element-85">
        <h2 className="text-3xl md:text-4xl font-['Orbitron'] font-light mb-8" data-id="element-86">
          Investment in <span className="text-white" data-id="element-87">Immortality</span>
        </h2>
        <p className="text-zinc-300 mb-8 leading-relaxed" data-id="element-88">
          Our preservation services start at $10,000, with customized solutions
          available for those who qualify. Each potential client undergoes a
          thorough evaluation process to ensure mutual compatibility.
        </p>
        <Link to="/pricing" className="inline-block px-8 py-4 border border-white/20 hover:border-white/30 rounded-sm transition-colors backdrop-blur-sm bg-black/30 tracking-wider" data-id="element-89">
          View Detailed Pricing
        </Link>
        <p className="text-zinc-500 mt-8 text-sm" data-id="element-90">
          By invitation only. Subject to qualification and compatibility
          assessment.
        </p>
      </div>
    </section>;
};